__turbopack_context__.v({
  "blok-big-title": "MediaCardBlok-module__Ts2SJa__blok-big-title",
  "blok-subtitle": "MediaCardBlok-module__Ts2SJa__blok-subtitle",
  "blok-title": "MediaCardBlok-module__Ts2SJa__blok-title",
  "image": "MediaCardBlok-module__Ts2SJa__image",
  "root": "MediaCardBlok-module__Ts2SJa__root",
  "socialIcon": "MediaCardBlok-module__Ts2SJa__socialIcon",
});
